export default __webpack_public_path__ + "static/media/pairi-daiza-logo.401a0653.png";